import { Injectable } from '@angular/core';
import { Worksheet, Workbook } from 'exceljs/dist/exceljs.min.js';

export interface WorkbookWrapper {
  xlsx: {
    writeBuffer();
  };
  addWorksheet: (name: string) => Worksheet;
  getWorksheet: (name: string) => Worksheet | undefined;
}

@Injectable()
export class WorkbookWrapperService {
  constructor() {}

  getWorkbook(): WorkbookWrapper {
    return new Workbook();
  }
}
